import { useMemo } from "react";
import { useFetchPutV2 } from "hooks/fetch/useFetchPutV2";

export function usePutRuleLevel(ruleLevelId) {
  const url = useMemo(() => `rule_levels/${ruleLevelId}`, [ruleLevelId]);

  const { loading, error, putCallback } = useFetchPutV2(url);

  return {
    loading,
    error,
    putRuleLevelCallback: putCallback
  };
}
